export default __webpack_public_path__ + "pin-green_dis.610342d7.svg";